var _templateObject = _taggedTemplateLiteralLoose(["\n  margin-bottom: 1rem;\n  @media (max-width: 786px) {\n    padding: 0px 15px;\n  }\n  box-shadow: none;\n  border: 1px solid #f2f2f2;\n  background-color: #fdfdfd;\n  transition: all 0.2s ease-in-out;\n  animation: slideDown 500ms both;\n  animation-delay: 0.2s;\n  padding-left: 15px;\n  padding-right: 15px;\n  &:hover {\n    box-shadow: -3px 0px 17px 1px #00000011 !important;\n  }\n  .small {\n    color: #999 !important;\n    letter-spacing: -0.0871296px !important;\n  }\n"], ["\n  margin-bottom: 1rem;\n  @media (max-width: 786px) {\n    padding: 0px 15px;\n  }\n  box-shadow: none;\n  border: 1px solid #f2f2f2;\n  background-color: #fdfdfd;\n  transition: all 0.2s ease-in-out;\n  animation: slideDown 500ms both;\n  animation-delay: 0.2s;\n  padding-left: 15px;\n  padding-right: 15px;\n  &:hover {\n    box-shadow: -3px 0px 17px 1px #00000011 !important;\n  }\n  .small {\n    color: #999 !important;\n    letter-spacing: -0.0871296px !important;\n  }\n"]);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component, Fragment } from "react";
import styled from "styled-components";
var Container = styled.div(_templateObject);

var Shadowed = function Shadowed(props) {
  return React.createElement(Container, {
    className: props.className
  }, props.children);
};

export default Shadowed;